import { buildBase } from "./constants";

const BASE = buildBase("showire");

export const SHOWIRE_ROUTES = (() => {
  const basicRoutes = {
    ROOT: BASE,
  };

  return {
    ...basicRoutes,
  };
})();
